export default __webpack_public_path__ + "static/media/logo-new-white-green-a5cb16e0ae.b593e716.svg";